import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=24c6aac5&scoped=true"
import script from "./Attribute.vue?vue&type=script&lang=js"
export * from "./Attribute.vue?vue&type=script&lang=js"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=24c6aac5&prod&lang=stylus&scoped=true"
import style1 from "./Attribute.vue?vue&type=style&index=1&id=24c6aac5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6aac5",
  null
  
)

export default component.exports